import * as React from 'react';
import { createContext, useContext } from 'react';

import type { PropsFromUseWallets } from 'bundles/payments-common/data/useWallets';
import { useWallets } from 'bundles/payments-common/data/useWallets';

type WalletsContextValue = PropsFromUseWallets;

const WalletsContext = createContext<WalletsContextValue | undefined>(undefined);

type WalletsProviderProps = {
  children: React.ReactNode;
};

export const WalletsProvider = ({ children }: WalletsProviderProps) => {
  const wallets = useWallets(undefined, true);

  return <WalletsContext.Provider value={wallets}>{children}</WalletsContext.Provider>;
};

export const useWalletsContext = (): WalletsContextValue => {
  const context = useContext(WalletsContext);
  if (context === undefined) {
    throw new Error('useWalletsContext must be used within a WalletsProvider');
  }
  return context;
};
